import React from "react";
import { GraphQLClient } from "graphql-request";
import { serialize } from "next-mdx-remote/serialize";

import ContentPage from "components/ContentPage";
import { navigationInfo } from "components/utils";
import Header from "components/__dynamic/header";
import Footer from "components/__dynamic/footer";
import Layout from "components/Layout";
import showdown from "showdown";

const graphcms = new GraphQLClient(process.env.NEXT_PUBLIC_GRAPHCMS);

const singlearticle = `query articles($slug: String!) {
    article(where: {slug: $slug}) {
        slug
        id
        title
        relevantdate
        abstract
        content {
            markdown
          }
          pdFs{
            url
            fileName
          }
        tags
        heroImage{
          url(transformation: {document: {output: {format: jpg}}})
          figureCaption
        }
    }
  }`;

const allarticles = `
query Articles() {
    articles(orderBy: relevantdate_ASC) {
      slug
      id
      title
      relevantdate
      abstract
      content {
        markdown
      }
      pdFs{
        url
        fileName
      }
      tags
      heroImage{
        url(transformation: {image: {resize: {fit: crop, height: 400, width: 400}}, document: {output: {format: jpg}}})
      }
    }
  }
`;

function ConvertMDXToHtml(proptext) {
    let converter = new showdown.Converter();

    let convertedText = converter.makeHtml(proptext);
    convertedText = convertedText.replace(/<[^>]*>/g, "");
    return convertedText.length > 200
        ? (convertedText = convertedText.slice(0, 200) + "...")
        : convertedText + "...";
}

export async function getStaticProps({ params }) {
    const { article } = await graphcms.request(singlearticle, {
        slug: params.slug,
    });
    const { navigation } = await graphcms.request(navigationInfo);

    if (article?.content) {
        article.mdxSource = await serialize(article.content?.markdown);
    }

    if (!article) {
        return {
            notFound: true,
        };
    }

    return {
        props: {
            article,
            navigation,
        },
    };
}

export async function getStaticPaths() {
    const { articles } = await graphcms.request(allarticles);

    return {
        paths: articles.map(({ slug }) => ({
            params: { slug },
        })),
        fallback: 'blocking',
    };
}

const Article = ({ article, navigation }) => {

    const ogData = {
        title: article.title ? article.title : "",
        description: ConvertMDXToHtml(article.content?.markdown),
        image: article.heroImage ? article.heroImage.url : "",
    };

    return article ? (
        <Layout pageTitle={article.title} metaData={ogData}>
            <Header
                backgroundColor="white"
                textColor="figma-secondaryone"
                textColorHover="figma-primary"
                dropdownColor="figma-primary"
                navigation={navigation}
            />
            <ContentPage navigation={navigation} {...article} />
            <Footer navigation={navigation} />
        </Layout>
    ) : (
        "Loading"
    );
};

export default Article;
